import { useNavigate } from 'react-router-dom';

import {
  isErrorWithMessage,
  openErrorNotification,
  openSuccessNotification,
} from 'shared/lib';

import { ConnectedUserForm, UserFormData } from 'entities/user';

import { ADD_SUCCESS, ADD_ERROR } from '../consts';

// TODO
import { useCustomAddUserMutation } from '../../../../redux/services/identity';
import { USER_ROUTES } from 'shared/consts/routes/user';

const initialValues: UserFormData = {
  id: '',
  userName: '',
  firstName: '',
  lastName: '',
  middleName: '',
  email: '',
  // status: '0',
  userPass: '',
  groupName: '',
};

export function AddUser() {
  const [trigger, { isLoading }] = useCustomAddUserMutation();

  const navigate = useNavigate();

  const handleSubmit = async (values: UserFormData) => {
    const { id, userPass, ...rest } = values;

    const req = {
      ...rest,
      password: userPass,
      // status: status === '0' ? false : true,
    };

    try {
      const res = await trigger(req).unwrap();

      // костыль
      if (res.statusCode !== 0) {
        openErrorNotification(res.statusDescription);

        return;
      }
      //

      openSuccessNotification(ADD_SUCCESS);

      navigate(USER_ROUTES.USERS);
    } catch (err) {
      const hasErrorMessage = isErrorWithMessage(err);

      const errorText = hasErrorMessage
        ? err.data.statusDescription
        : ADD_ERROR;

      openErrorNotification(errorText);
    }
  };

  return (
    <ConnectedUserForm
      title="Добавление нового пользователя"
      handleSubmit={handleSubmit}
      initialValues={initialValues}
      loading={isLoading}
    />
  );
}
